// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".userForm{\n  display: flex;\n  flex-wrap: wrap;\n\n   /* flex-direction:column; */\n\n\n\n}", "",{"version":3,"sources":["webpack://./src/screens/User/user.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;;GAEd,2BAA2B;;;;AAI9B","sourcesContent":[".userForm{\n  display: flex;\n  flex-wrap: wrap;\n\n   /* flex-direction:column; */\n\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
